// Angular
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
// RxJS
import { Observable, BehaviorSubject } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { AuthService } from '../../../../../core/auth/_services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../../../../../environments/environment';

var swRegistration: any = null;
@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user$: Observable<User>;
	user2: User = new User();
	userCurrent = new BehaviorSubject<User>(this.user2);
	isReset: any;

	@Input() avatar: boolean = true;
	@Input() greeting: boolean = true;
	@Input() badge: boolean;
	@Input() icon: boolean;
	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(private store: Store<AppState>,
		private auth: AuthService,
		private cdr: ChangeDetectorRef,
		private router: Router) {
		this.user2.clear();
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		let user = JSON.parse(localStorage.getItem("UserInfo"));
		this.user2.fullname = user.fullname;
		this.user2.email = user.email;
		this.user2.chucdanh = user.TenChucDanh;
		this.userCurrent.next(this.user2);
		this.user$ = this.store.pipe(select(currentUser));
		this.permissionNof();
		this.isReset = setInterval(() => {
			this.resetSession();
		}, 240000);
	}

	/**
	 * Log out
	 */
	async logout() {
		// this.store.dispatch(new Logout());
		try {
			if (swRegistration !== undefined) {
				var auth = this.auth;
				await swRegistration.pushManager.getSubscription()
					.then(function (subscription) {
						if (subscription) {
							auth.DeleteFCM(subscription).subscribe(res => { });
							clearInterval(this.isReset);
							this.auth.logout(true);
							return subscription.unsubscribe();
						}
					})
					.catch(function (error) {
					});
			}
			clearInterval(this.isReset);
			this.auth.logout(true);
		}
		catch (ex) {
			clearInterval(this.isReset);
			this.auth.logout(true);
			//this.router.navigate(['/login']);
		}
	}

	resetSession() {
		try {
			this.auth.resetSession().subscribe(res => {
				if (res && res.status == 1) {

					let user = JSON.parse(localStorage.getItem("UserInfo"));

					user.accessToken = res.data;

					localStorage.setItem('UserInfo', JSON.stringify(user));
				} else {
					this.router.navigate(['/login']);
				}
			});
		}
		catch (ex) {
			this.router.navigate(['/login']);
		}
	}
	permissionNof() {
		if (Notification && Notification.permission !== "granted") {
			Notification.requestPermission(function (status) {
				if (Notification.permission !== status) {
					//Notification.permission = status;
				}
			});
		}
		if ('serviceWorker' in navigator && 'PushManager' in window) {
			var auth = this.auth;
			navigator.serviceWorker.register('sw.js')
				.then(function (swReg) {
					swRegistration = swReg;
					auth.CreateFCM().subscribe(res => {
						if (res && res.status == 1) {
							var token = localStorage.getItem('PublicKey')
							if (token != res.data)//token mới
							{
								localStorage.setItem('PublicKey', res.data);
								let user = JSON.parse(localStorage.getItem("UserInfo"));
								swReg.active.postMessage(JSON.stringify({
									Token: user.accessToken,
									ApiUrl: environment.ApiRoot,
									applicationServerPublicKey: res.data
								}));
							}
						}
					});
				})
				.catch(function (error) {
					console.error('Service Worker Error', error);
				});
		} else {
			console.warn('Service Worker and Push is not supported');
		}
	}
}
